import { render, staticRenderFns } from "./BackButton.vue?vue&type=template&id=5c0631cd&scoped=true&"
import script from "./BackButton.vue?vue&type=script&lang=js&"
export * from "./BackButton.vue?vue&type=script&lang=js&"
import style0 from "./BackButton.vue?vue&type=style&index=0&id=5c0631cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0631cd",
  null
  
)

export default component.exports